// extracted by mini-css-extract-plugin
export default {"container":"CardsContainer_container__ekZJg","filters":"CardsContainer_filters__yFwZq","pagination":"CardsContainer_pagination__8V2GQ","loader":"CardsContainer_loader__kl6M1"};